module.exports = __webpack_public_path__ + "img/logo.2b4659f5.png";